import React from "react";
import { ButtonControl, DialogControl } from "spark-core-dx/components";

const AiMappingConfirmDialog = ({ open, summary, warnings, canApprove = true, onCancel, onConfirm }) => {
  return (
    <DialogControl
      openDialog={open}
      title={"Apply AI Mapping Suggestions"}
      onX={onCancel}
      onCancel={onCancel}
      onOk={canApprove ? onConfirm : undefined}
      hideButtonRow={!canApprove}
      cancelText={canApprove ? "Decline" : "OK"}
      okText={canApprove ? "Approve" : ""}
    >
      <div className="efmd-dialog">
        <div className="efmd-summary">
          <div>Added: {summary?.added || 0}</div>
          <div>Removed: {summary?.removed || 0}</div>
          <div>Replaced: {summary?.replaced || 0}</div>
        </div>
        {warnings?.length > 0 && (
          <div className={`efmd-warnings ${canApprove ? "is-info" : "is-error"}`}>
            {warnings.map((warning, index) => (
              <div key={`warn-${index}`}>{warning}</div>
            ))}
          </div>
        )}
        <div className="efmd-ai-caution">
          AI suggestions may require review. Please confirm mappings before approval. Suggestions are based on each field&apos;s
          Field Name, Display Name, Description, and AI Prompt Context.
        </div>
        {!canApprove && (
          <div className="efmd-dialog__single-action">
            <ButtonControl type={"standard"} onClick={onCancel}>
              OK
            </ButtonControl>
          </div>
        )}
      </div>
    </DialogControl>
  );
};

export default AiMappingConfirmDialog;
